import React from "react";
import "./ResponsablesSection.css";

const ResponsablesSection = ({ responsables }) => {
    // Données par défaut pour coller à la maquette si la prop est vide ou pour tester le design
    const defaultResponsables = [
        { name: "Kevin Jarnot", role: "ENTRAÎNEUR PRINCIPAL", phone: "06 XX XX XX XX", email: "coach@ndbf.fr", image: "/images/staff/kevin.jpg" },
        { name: "Reynald", role: "ENTRAÎNEUR ADJOINT", phone: "06 XX XX XX XX", email: "assistant@ndbf.fr", image: "/images/staff/reynald.jpg" },
        { name: "Ali", role: "DIRIGEANT", phone: "06 XX XX XX XX", email: "ndb9futsal@gmail.com", image: "/images/staff/ali.jpg" }
    ];

    const displayData = responsables.length > 0 ? responsables : defaultResponsables;

    return (
        <div className="responsables-section">
            <h2 className="section-title">Représentants de l'équipe</h2>
            <div className="responsables-grid">
                {displayData.map((resp, index) => (
                    <div key={index} className="responsable-card-new">
                        <div className="responsable-content">
                            <div className="responsable-image-wrapper">
                                {/* Placeholder si pas d'image, ou icône user */}
                                {resp.image ? (
                                    <img src={resp.image} alt={resp.name} className="responsable-img" />
                                ) : (
                                    <div className="responsable-placeholder-icon">👤</div>
                                )}
                            </div>
                            <div className="responsable-info">
                                <h3>{resp.name}</h3>
                                <span className="responsable-role">{resp.role}</span>
                                <div className="responsable-contact">
                                    <span className="contact-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="var(--or-color)" className="contact-icon">
                                            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                                        </svg>
                                        {resp.phone || "N/C"}
                                    </span>
                                    {/* Email Removed */}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ResponsablesSection;
